"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltippedToggle = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./TooltipToggle.css"));
var react_1 = __importDefault(require("react"));
var TooltippedToggle = function (_a) {
    var tooltipImage = _a.tooltipImage, label = _a.label, labelHidden = _a.labelHidden, value = _a.value, onChange = _a.onChange, showTooltip = _a.showTooltip, disabled = _a.disabled;
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { className: styles.previewTooltips, position: kaleidoscope_1.TooltipPosition.Right, content: react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", padding: "xxs" },
            react_1.default.createElement("img", { src: tooltipImage, width: "480px", className: styles.tooltipImage, alt: label }),
            react_1.default.createElement(kaleidoscope_1.Text, null, "Buyer will see this")), autoStack: true, wrapTarget: true, offset: 30, show: showTooltip },
        react_1.default.createElement(kaleidoscope_1.Toggle, { className: styles.paymentOptionToggle, disabled: disabled, label: label, labelHidden: labelHidden, onChange: onChange, value: value })));
};
exports.TooltippedToggle = TooltippedToggle;
